import React, { useState } from 'react';

function StallCard({ stall, onClick }) {
  const [hov, setHov] = useState(false);

  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={() => onClick(stall)}
      style={{
        background: hov ? stall.color : '#fff',
        border: `1px solid ${hov ? stall.accent + '40' : '#e8e4e0'}`,
        borderRadius: 16,
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'all 0.25s ease',
        transform: hov ? 'translateY(-4px)' : 'none',
        boxShadow: hov
          ? `0 12px 32px ${stall.accent}22`
          : '0 2px 8px rgba(0,0,0,0.04)',
      }}
    >
      {/* Card image area */}
      <div
        style={{
          height: 180,
          background: stall.color,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {stall.images && stall.images[0] ? (
          <img
            src={stall.images[0]}
            alt={stall.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <div style={{ fontSize: 56 }}>{stall.icon}</div>
          </div>
        )}

        {/* ID badge */}
        <div
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'rgba(255,255,255,0.85)',
            backdropFilter: 'blur(8px)',
            borderRadius: 6,
            padding: '3px 8px',
            fontSize: 10,
            letterSpacing: 1,
            textTransform: 'uppercase',
            color: stall.accent,
            fontWeight: 600,
          }}
        >
          {stall.id}
        </div>

        {/* Image count badge */}
        {stall.images && stall.images.length > 1 && (
          <div style={{
            position: 'absolute', bottom: 10, right: 12,
            background: 'rgba(0,0,0,0.45)', borderRadius: 20,
            padding: '2px 8px', fontSize: 10, color: '#fff',
          }}>
            1 / {stall.images.length}
          </div>
        )}
      </div>

      {/* Card body */}
      <div style={{ padding: '1.25rem' }}>
        <h3
          style={{
            fontFamily: 'DM Serif Display',
            fontSize: 18,
            color: '#1a1a1a',
            marginBottom: 6,
          }}
        >
          {stall.name}
        </h3>
        <p
          style={{
            fontSize: 12,
            color: '#888',
            lineHeight: 1.5,
            marginBottom: 12,
          }}
        >
          {stall.desc.slice(0, 70)}…
        </p>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', gap: 6 }}>
            <span
              style={{
                fontSize: 10,
                background: '#f0ede8',
                borderRadius: 4,
                padding: '2px 7px',
                color: '#666',
              }}
            >
              {stall.area}m²
            </span>
            <span
              style={{
                fontSize: 10,
                background: '#f0ede8',
                borderRadius: 4,
                padding: '2px 7px',
                color: '#666',
                textTransform: 'capitalize',
              }}
            >
              {stall.size}
            </span>
          </div>
          <span style={{ fontSize: 11, color: stall.accent, fontWeight: 500 }}>
            View →
          </span>
        </div>
      </div>
    </div>
  );
}

export default StallCard;
